import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Table,
} from "reactstrap";
import "./index.css";
import { useTab } from "@mui/base";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import { Checkbox } from "@material-ui/core";
import DatePicker from "react-datepicker";
import { DatePickerField } from "../../../core/inputs/input";
import { useRef } from "react";
import AddFreight from "../../../TripsMainV2/Components/AddFreight";
import { getDriverList } from "../../../../services/Store/Actions/driverslistActions";
import { toast, ToastContainer } from "react-toastify";
import {
  createTrip,
  getCityAndState,
  getLRList,
} from "../../../../services/Store/Actions/TripsAction";
import moment from "moment";
import { getCityAndStateAction } from "../../../../services/Store/Actions/omcActions";
import AddDriverV2 from "../../../TripsMainV2/Components/AddDriverV2";
import AddVehicleV2 from "../../../TripsMainV2/Components/AddVehicleV2";
import InvoiceToast from "../../../subComponents/InvoiceToast";
import {
  storeMedia,
  toastStatus,
} from "../../../../services/Store/Actions/appActions";
import { useNavigate } from "react-router-dom";
import {
  addPaymentRecivedAction,
  addPaymentRecivedTripAction,
  getInvoiceListAction,
  getLedgerListAction,
} from "../../../../services/Store/Actions/customerAction";
import { ClipLoader } from "react-spinners";
import FormPicker from "../../../core/FormPicker";
import {
  editVendorAciton,
  getVendorDetailsAction,
  transferTorVendorAction,
} from "../../../../services/Store/Actions/beneficiaryAction";
import PinInput from "react-pin-input";

function PayVendor(props) {
  const { toggle, modal, setModal, offset, vendorData, tripData } = props;
  const [openToast, setOpenToast] = useState(false);
  const [status, setStatus] = useState(false);
  const [invoiceTotal, setInvoiceTotal] = useState(0);
  const [imageLoader, setImageLoader] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [markedInvoices, setMarkCleared] = useState(null);
  const [offset2, setOffset2] = useState(false);
  const [edit, setEdit] = useState(0);
  const [loader2, setLoader2] = useState(false);
  const [loader, setLoader] = useState(false);
  const { vendorDetails } = useSelector((state) => state?.beneficiary);
  console.log("svendorDetailsvendorDetails", vendorDetails);
  let { freightList, freightListCount } = useSelector((store) => store?.trip);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [display, setDisplay] = useState(false);
  const [color, setColor] = useState(-1);

  const validationSchema = Yup.object().shape({
    amount: Yup.string().required("amount is required"),
    // receipt: Yup.string().required("receipt is required"),

    // txnNumber: Yup.string().required("txnNumber is required"),

    // remarks: Yup.string().required("remarks is required"),
  });
  const handleClose = () => {
    setModal(!modal);
  };

  //   useEffect(() => {
  //     dispatch(getVendorDetailsAction({ id: tripData?.vendorId }, (resp) => {}));
  //   }, []);

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
        // style={{borderRadius : "10px"}}
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
          // style={{ height: "80vh" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{ marginTop: " 30px" }}
            //   className="PGCollectionBox"
          >
            <div
              className="PGCollectiontText col-9"
              style={{ marginLeft: "50px" }}
            >
              Pay Vendor {tripData?.tripNo ? " | " + tripData?.tripNo : ""}
            </div>

            <Formik
              // isValid='true'
              enableReinitialize
              validationSchema={validationSchema}
              initialValues={{
                amount: "",
                pin: "",
                remarks: "",
                transactionMode: "",
                bankAccountNumber: vendorDetails?.bankAccountNumber,
                ifsc: vendorDetails?.ifsc,
                vpaId: vendorDetails?.vpaId,
                name: vendorDetails?.name,
                phone: vendorDetails?.phone,
              }}
              onSubmit={(values) => {
                console.log("bjbegduofgwuoegoi", values, vendorDetails);
                const handleCloseToast = () => {
                  dispatch(
                    toastStatus({
                      toastStatus: false,
                    })
                  );
                };
                const toggleModalToast = () => {
                  dispatch(
                    toastStatus({
                      toastStatus: false,
                    })
                  );
                };
                setLoader(true);
                dispatch(
                  transferTorVendorAction(
                    {
                      mode:
                        (values?.vpaId != null || values?.vpaId != "") &&
                        (values?.bankAccountNumber != "" ||
                          values?.bankAccountNumber != null)
                          ? values?.transactionMode == "Bank Transfer"
                            ? "BANK_TRANSFER"
                            : "UPI"
                          : values?.vpaId == "" || values?.vpaId == null
                          ? "BANK_TRANSFER"
                          : "UPI",
                      pin: values?.pin?.toString(),
                      amount: values?.amount?.toString(),
                      remark: values?.remarks,
                      vendorId: vendorDetails?.vendorId?.toString(),
                      tripId: tripData?.tripId,
                    },
                    (res) => {
                      setLoader(false);
                      console.log("res?.datatransferTorVendorAction", res);
                      if (res?.status == 200) {
                        handleClose();
                      } else {
                      }
                    },
                    toggleModalToast,
                    handleCloseToast
                  )
                );
              }}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  style={{ marginTop: "60px", padding: "0 30px 0 30px" }}
                >
                  <div style={{}} className="row">
                    <div className="col-6">
                      <div>
                        <div className="row">
                          <div className="col-7 FontNB20 mb-2">
                            Vendor Details
                          </div>
                          <div
                            className={`col-3 FontNS14 mb-2 ${
                              edit
                                ? "btnCatSelected heading4 Medium"
                                : "btnCat heading4 Medium"
                            }`}
                            style={{ width: "55px", cursor: "pointer" }}
                            onClick={() => {
                              setEdit(!edit);
                            }}
                          >
                            Edit
                          </div>
                        </div>

                        <FormGroup className="">
                          {/* <div className="FontNB semiBold">All Load Receipt</div> */}
                        </FormGroup>
                        <div className="row">
                          <div className="col-12 row">
                            <div
                              className="col-6 "
                              style={{ paddingTop: "10px" }}
                            >
                              <label for="vrn" className="heading3 semiBold">
                                Vendor Name
                              </label>
                            </div>

                            <div className="col-6" style={{ padding: "8px" }}>
                              <input
                                type="text"
                                readOnly={edit ? false : true}
                                invoiceId="name"
                                className={`inputBoxAddCust ${
                                  touched.name && errors.name
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="name"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "name",
                                    event.target.value,
                                    true
                                  );
                                }}
                                value={values.name}
                                touched={touched.name}
                                errors={errors.name}
                                placeholder="Enter Transaction Number"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.name && touched.name ? (
                                  <div>*{errors.name}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 row">
                            <div
                              className="col-6 "
                              style={{ paddingTop: "10px" }}
                            >
                              <label for="vrn" className="heading3 semiBold">
                                Vendor Phone
                              </label>
                            </div>

                            <div className="col-6" style={{ padding: "8px" }}>
                              <input
                                type="text"
                                readOnly={edit ? false : true}
                                invoiceId="phone"
                                className={`inputBoxAddCust ${
                                  touched.phone && errors.phone
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="phone"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "phone",
                                    event.target.value,
                                    true
                                  );
                                }}
                                value={values.phone}
                                touched={touched.phone}
                                errors={errors.phone}
                                placeholder="Enter Transaction Number"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.phone && touched.phone ? (
                                  <div>*{errors.phone}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 row">
                            <div
                              className="col-6 "
                              style={{ paddingTop: "10px" }}
                            >
                              <label for="vrn" className="heading3 semiBold">
                                Bank Account Number
                              </label>
                            </div>
                            <div className="col-6" style={{ padding: "8px" }}>
                              <input
                                type="text"
                                readOnly={edit ? false : true}
                                invoiceId="bankAccountNumber"
                                className={`inputBoxAddCust ${
                                  touched.bankAccountNumber &&
                                  errors.bankAccountNumber
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="bankAccountNumber"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "bankAccountNumber",
                                    event.target.value,
                                    true
                                  );
                                }}
                                value={values.bankAccountNumber}
                                touched={touched.bankAccountNumber}
                                errors={errors.bankAccountNumber}
                                placeholder="Enter Transaction Number"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.bankAccountNumber &&
                                touched.bankAccountNumber ? (
                                  <div>*{errors.bankAccountNumber}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 row">
                            <div
                              className="col-6"
                              style={{ paddingTop: "10px" }}
                            >
                              <label for="vrn" className="heading3 semiBold">
                                Ifsc
                              </label>
                            </div>
                            <div className="col-6" style={{ padding: "8px" }}>
                              <input
                                type="text"
                                readOnly={edit ? false : true}
                                invoiceId="ifsc"
                                className={`inputBoxAddCust ${
                                  touched.ifsc && errors.ifsc
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="ifsc"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "ifsc",
                                    event.target.value,
                                    true
                                  );
                                }}
                                value={values.ifsc}
                                touched={touched.ifsc}
                                errors={errors.ifsc}
                                placeholder="Enter ifsc"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.ifsc && touched.ifsc ? (
                                  <div>*{errors.ifsc}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 row">
                            <div
                              className="col-6"
                              style={{ paddingTop: "10px" }}
                            >
                              <label for="vpaId" className="heading3 semiBold">
                                VPA Id
                              </label>
                            </div>
                            <div className="col-6" style={{ padding: "8px" }}>
                              <input
                                type="text"
                                readOnly={edit ? false : true}
                                invoiceId="vpaId"
                                className={`inputBoxAddCust ${
                                  touched.vpaId && errors.vpaId
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="vpaId"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "vpaId",
                                    event.target.value,
                                    true
                                  );
                                }}
                                value={values.vpaId}
                                touched={touched.vpaId}
                                errors={errors.vpaId}
                                placeholder="Enter vpaId"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.vpaId && touched.vpaId ? (
                                  <div>*{errors.vpaId}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          {}
                          {edit ? (
                            <FormGroup
                              style={{
                                padding: "5% 0 0 0",
                                textAlign: "center",
                                // backgroundColor: "red",
                              }}
                            >
                              <Button
                                type="button"
                                style={{
                                  width: "100px",
                                  borderRadius: "5px",
                                  // bottom: 20,
                                  // position: "absolute",
                                  backgroundColor: "#485B7C",
                                }}
                                className="generateOtp textAddCust Medium btn btn-secondary"
                                disabled={edit ? false : true}
                                onClick={() => {
                                  let d = {
                                    id: tripData?.vendorId,
                                  };
                                  if (values?.bankAccountNumber) {
                                    d["bankAccountNumber"] =
                                      values?.bankAccountNumber;
                                  }
                                  if (values?.ifsc) {
                                    d["ifsc"] = values?.ifsc;
                                  }
                                  if (values?.vpaId) {
                                    d["vpaId"] = values?.vpaId;
                                  }
                                  setLoader2(true);
                                  dispatch(
                                    editVendorAciton(d, (res) => {
                                      console.log("asdasdasdsad ");
                                      setLoader2(false);
                                      if (res?.status == 200) {
                                        setEdit(false);
                                      } else {
                                        dispatch(
                                          toastStatus({
                                            toastStatus: true,
                                            message: res?.data?.message,
                                            status: false,
                                          })
                                        );
                                      }
                                    })
                                  );
                                }}
                              >
                                {loader2 ? (
                                  <>
                                    <ClipLoader
                                      color={"#fff"}
                                      loading={true}
                                      size={20}
                                      aria-label="Loading Spinner"
                                      data-testid="loader"
                                    />
                                  </>
                                ) : (
                                  "Submit"
                                )}
                              </Button>
                            </FormGroup>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <FormGroup
                        // style={{
                        //   display: "flex",
                        //   alignItems: "center",
                        //   justifyContent: "space-between",
                        //   marginTop: "30px",
                        // }}
                        style={{
                          padding: "20px 0 0 0",
                        }}
                      >
                        <div className="row">
                          <div className="col-6 row">
                            <div className="col-12">
                              <label for="vrn" className="heading3 semiBold">
                                Total Amount
                              </label>
                            </div>
                            <div className="col-12" style={{ padding: "8px" }}>
                              <input
                                type="number"
                                invoiceId="amount"
                                className={`inputBoxAddCust ${
                                  touched.amount && errors.amount
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="amount"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "amount",
                                    event.target.value,
                                    true
                                  );
                                }}
                                value={values.amount}
                                touched={touched.amount}
                                errors={errors.amount}
                                placeholder="enter amount"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.amount && touched.amount ? (
                                  <div>*{errors.amount}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-6 row">
                            <div className="col-12">
                              <label for="vrn" className="heading3 semiBold">
                                Remarks
                              </label>
                            </div>
                            <div className="col-12" style={{ padding: "8px" }}>
                              <input
                                type="text"
                                invoiceId="remarks"
                                className={`inputBoxAddCust ${
                                  touched.remarks && errors.remarks
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="remarks"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "remarks",
                                    event.target.value,
                                    true
                                  );
                                }}
                                value={values.remarks}
                                touched={touched.remarks}
                                errors={errors.remarks}
                                placeholder="Enter remarks"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.remarks && touched.remarks ? (
                                  <div>*{errors.remarks}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup
                        // style={{
                        //   display: "flex",
                        //   alignItems: "center",
                        //   justifyContent: "space-between",
                        //   marginTop: "30px",
                        // }}
                        style={{
                          padding: "20px 0 0 0",
                        }}
                      >
                        <div className="row">
                          <div className="col-6 row">
                            <div className="col-12">
                              <label for="vrn" className="heading3 semiBold">
                                Transaction Mode
                              </label>
                            </div>

                            <div className="col-12" style={{ padding: "8px" }}>
                              <input
                                type="text"
                                invoiceId="transactionMode"
                                className={`inputBoxAddCust ${
                                  touched.transactionMode &&
                                  errors.transactionMode
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="transactionMode"
                                onChange={(event) => {
                                  setDisplay("transactionMode");
                                  setFieldValue(
                                    "transactionMode",
                                    event.target.value,
                                    true
                                  );
                                }}
                                onFocus={() => {
                                  setDisplay("transactionMode");
                                }}
                                value={values.transactionMode}
                                touched={touched.transactionMode}
                                errors={errors.transactionMode}
                                placeholder="Enter Transaction Mode"
                                onBlur={() => {
                                  handleBlur("transactionMode");
                                  setDisplay("");
                                }}
                                autoComplete="off"
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.transactionMode &&
                                touched.transactionMode ? (
                                  <div>*{errors.transactionMode}</div>
                                ) : null}
                              </div>
                              <FormPicker
                                placeholder="Search"
                                // text="Select by driver name"
                                listing={["Bank Transfer", "UPI"]}
                                parameter="transactionMode"
                                minWidth={"180"}
                                // handlingDivSelect={handlingDivSelect}
                                display={display}
                                setDisplay={setDisplay}
                                // displayVehicles={displayVehicles}
                                // setDisplayVehicles={setDisplayVehicles}
                                color={color}
                                setColor={setColor}
                                //   loading={loading}
                                setFieldValue={setFieldValue}
                                setFieldParameter={"transactionMode"}
                                header={"transactionMode"}
                                autoComplete="off"
                                // userId={userId}
                                // setUserId={setUserId}
                              />
                            </div>
                            <div
                              style={{
                                // margin: "0px -16px 2px -614px",
                                color: "red",
                              }}
                            >
                              {errors.receipt && touched.receipt ? (
                                <div>*{errors.receipt}</div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-6 row">
                            <div className="col-12">
                              <label for="vrn" className="heading3 semiBold">
                                Enter 4-digit Pin
                              </label>
                            </div>
                            <div className="col-12" style={{ padding: "8px" }}>
                              <PinInput
                                name="pin"
                                length={4}
                                initialValue=""
                                secret
                                onChange={(value, index) =>
                                  setFieldValue("pin", value, true)
                                }
                                type="numeric"
                                inputMode="number"
                                style={
                                  {
                                    //   padding: "10px",
                                    //   marginLeft: "96px",
                                    //   marginTop: "28px",
                                  }
                                }
                                inputStyle={{
                                  border: "1px solid #A7A7A7",
                                  borderRadius: "8px",
                                  marginRight: "5px",
                                  width: "35px",
                                  height: "35px",
                                }}
                                onComplete={(value, index) => {}}
                                autoSelect={true}
                                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                              />
                              <div
                                style={{
                                  margin: "7px 0 0px 5px",
                                  color: "red",
                                }}
                              >
                                {errors.remarks && touched.remarks ? (
                                  <div>*{errors.remarks}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup
                        style={{
                          padding: "5% 0 0 0",
                          textAlign: "center",
                          // backgroundColor: "red",
                        }}
                      >
                        <Button
                          type="submit"
                          style={{
                            width: "160px",
                            borderRadius: "5px",
                            // bottom: 20,
                            // position: "absolute",
                            backgroundColor:
                              values?.amount == "0" ? "#6c757d" : "#485B7C",
                          }}
                          disabled={loader || values?.amount == "0"}
                          className="generateOtp textAddCust Medium btn btn-secondary"
                          // onClick={addFreight}
                        >
                          {loader ? (
                            <>
                              <ClipLoader
                                color={"#fff"}
                                loading={true}
                                size={20}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                              />
                            </>
                          ) : (
                            "Pay"
                          )}
                        </Button>
                      </FormGroup>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>

      {/* <InvoiceToast
        success={true}
        message={"Customer Created Successfully "}
        toggleModal={() => {
          setOpenToast(false);
        }}
        isOpen={openToast}
        name="driver"
        handleClose={() => {
          setOpenToast(false);
          //   window.location = "/Customers";
          navigate("/Customers/" + customer.customerId);
          dispatch(
            getLedgerListAction({
              customerId: customer.customerId,
              offset: offset,
              search: "",
              transferType: "",
              sortAs: "",
              sortBy: "",
            })
          );
        }}
      /> */}
      <ToastContainer
        theme="dark"
        position="bottom-right"
        closeOnClick
        pauseOnHover
        autoClose={4000}
      />
    </div>
  );
}

export default PayVendor;
